import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment'
import { SharedService } from '../../../../shared/shared.service';
import { CollectionReference, DocumentData, Firestore,collection, addDoc, collectionData, doc, docData, documentId, getDocs, query, updateDoc, where, deleteDoc, getDoc } from '@angular/fire/firestore';
import { BehaviorSubject, Observable } from 'rxjs';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { firstValueFrom } from 'rxjs';


@Injectable({
    providedIn: 'root'
})

export class DashboardService {
	progressCollection: CollectionReference<DocumentData>;
	programsCollection: CollectionReference<DocumentData>;
	inspirationalQuotesCollection: CollectionReference<DocumentData>;
	buzzSproutApiUrl = "https://www.buzzsprout.com/api/2212663/episodes.json";
	teamAnalyticsData: any;
	teamAnalyticsDataFetch$ = new BehaviorSubject("sleeping");

    constructor(
		private fns: AngularFireFunctions,
		private http: HttpClient,
		private firestore: Firestore,
		private httpClient: HttpClient,
		private sharedService: SharedService
	) {
		this.progressCollection = collection(this.firestore, "progress");
		this.programsCollection = collection(this.firestore, "programs");
		this.inspirationalQuotesCollection = collection(this.firestore, "inspirationalQuotes");
	}

	async getUserProgress(userId: string, programId: string) {
		try {
			const progressId = userId + "_" + programId;
			// console.log(progressId);
			const docRef = doc(this.firestore, `progress/${progressId}`);
			const progressDataObs = docData(docRef);

			const progressData: any = await this.sharedService.getObservableRes(progressDataObs);
			// console.log(progressData);

			if (progressData && Object.keys(progressData).length >= 1) {
				return progressData;
			} else {
				return {};
			}
		} catch (err) {
			console.log('Unable to get user progress stats', err);
		}
	}


	async getUserProgressAnalytics(userId: any) {
		try {
			// console.log('userId',userId)
			let q;
				const progressData = collection(this.firestore, `progress`);
				q = query(progressData, where('userId', '==', userId))
				let obs = collectionData(q,  { idField: 'id' }) as Observable<any>;
				// console.log('obs: ' + obs);
				let result = await this.sharedService.convertObsToValue(obs);
    			// console.log(result);
				return result;
				// if (data && Object.keys(data).length >= 1) {
				// 	return data;
				// } else {
				// 	return {};
				// }

		} catch (err) {
			console.log('Unable to get user progress stats', err);
		}
	}

	async getQuotes() {
		try {
			// let quotes = localStorage.getItem("inspirationalQuotes");
			// if (quotes) {
			// 	return JSON.parse(quotes);
			// }

			const quotesObs = collectionData(this.inspirationalQuotesCollection);
			let quotes = await this.sharedService.convertObsToValue(quotesObs);
			localStorage.setItem("inspirationalQuotes", JSON.stringify(quotes));
			// console.log('quotes', quotes);
			return quotes;
		} catch (err) {
			console.log('Unable to get inspirational quotes', err);
			return []
		}
	}

	async makeCodesLowercase() {
		try {
			const userDataObs = collectionData(collection(this.firestore, 'users'), {
				idField: "id"
			});
			const userData: any = await this.sharedService.getObservableRes(userDataObs);
			userData.forEach(async (user: any) => {
				if (user.empCode) {
					const userRef = doc(this.firestore, `users/${user.id}`);
					let empCode = String(user.empCode).toLowerCase().trim();

					await updateDoc(userRef, {
						empCode
					});
				}
			});
		} catch (err) {
			console.log('Unable to make codes lowercase', err);
		}
	}

	async updateLoginTime(userId: string, loginHistory: any) {
		try {
			await updateDoc(doc(this.firestore, `users/${userId}`), {
				loginHistory
			});
		} catch (err) {
			console.log('Unable to update login time', err);
		}
	}

	async updateProgramLastAccess(progressId: string) {
		try {
			await updateDoc(doc(this.firestore, `progress/${progressId}`), {
				lastUpdatedAt: new Date()
			});
		} catch (err) {
			console.log('Unable to update login time', err);
		}
	}

	async getMiniClipCoverImage() {
		try {
			const miniClipCoverImageObs = docData(doc(this.firestore, "settings/miniclipData"));
			let miniClipCoverImage = await this.sharedService.convertObsToValue(miniClipCoverImageObs);
			return miniClipCoverImage;
		} catch (err) {
			console.log('Unable to get inspirational quotes', err);
		}
	}

	async getUserData() {
		const userId = localStorage.getItem('userId');

		if (userId) {
			const docSnap = await getDoc(doc(this.firestore, `users/${userId}`));
			return docSnap.data();
		}
	}

	async getPodcasts() {
		const httpOptions = this.getHttpHeaders();
		const podcastsObs = this.http.get(this.buzzSproutApiUrl, httpOptions);
		return await this.sharedService.getObservableRes(podcastsObs);
	}

	getHttpHeaders() {
		return {
			headers: {
				Authorization: "Token token=53fea694b7ce43267848295444a6b692"
			}
		}
	}

	async updateUserData(userId: string, data: any) {
		try {
			let docRef = doc(this.firestore, `users/${userId}`);
			await updateDoc(docRef, data);
		} catch (err) {
			console.log("unable to update user data");
		}
	}

	async getDailyQuotesData() {
		try {
			let docRef = doc(this.firestore, "dailyQuotesData/images");
			const docSnap = await getDoc(docRef);
			const docData: any = docSnap.data();
			return docData["data"];
		} catch (err) {
			console.log("unable to get daily quotes");
		}
	}

	async updateQuoteIndex(uid:string, index:number) {
		try {
			const userDocRef = doc(this.firestore, `users/${uid}`);
			await updateDoc(userDocRef, { quoteIndex: index });
		} catch (err) {
			console.log("Error while updating quoteIndex: ", err);
		}
	}

	async getTeamAnalyticsData(orgId: string) {
		try {
			if (!orgId) {
				this.teamAnalyticsData = "";
			}

			const orgData: any = await this.getOrgData(orgId);
			if (orgData.analyticsUrl) {
				this.teamAnalyticsDataFetch$.next("pending");
				const analyticsUrl = orgData.analyticsUrl.includes("?")
					? `${orgData.analyticsUrl}&v=${Date.now()}&ngsw-bypass=true`
					: `${orgData.analyticsUrl}?v=${Date.now()}&ngsw-bypass=true`;

				let analyticsDataRes: any;
				try {
					analyticsDataRes = await firstValueFrom(this.http.get(analyticsUrl));
				} catch (firstErr) {
					const retryUrl = `${analyticsUrl}&retry=${Date.now()}`;
					analyticsDataRes = await firstValueFrom(this.http.get(retryUrl));
				}
				// console.log(analyticsDataRes);
				this.teamAnalyticsData = analyticsDataRes;
				this.teamAnalyticsDataFetch$.next("resolved");
				console.log("Got TA data!");
			}
		} catch (err) {
			console.log(err);
		}
	}

	async rebuildTeamAnalytics(orgId: string) {
		try {
			const rebuildAnalyticsCallable = this.fns.httpsCallable('analytics-rebuildOrgAnalytics');
			return await firstValueFrom(rebuildAnalyticsCallable({ orgId }));
		} catch (err) {
			console.log('Unable to rebuild team analytics', err);
			throw err;
		}
	}

	async getOrgData(orgId: string) {
		try {
			if (orgId) {
				let docRef = doc(this.firestore, `organisations/${orgId}`);
				const orgDataObs = docData(docRef, {
					idField: "id"
				});
				return await this.sharedService.getObservableRes(orgDataObs);
			}
			return "";
		} catch (err) {
			console.log('Unable to get org levels!', err);
		}
	}
}
